<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent"><a id="page_15"></a></p>
<p class="noindent"><a id="ch1"></a></p>
<h2 class="h2"><strong><em>WALK 1 : Meeting Brunetti</em></strong></h2>
<p class="center1">San Fantin—Sant’Angelo—Manin—San Luca—San Bartolomeo</p>
<p class="center">1.5 hours</p>
<p class="image"><img alt="Image" src="images/f0015-01.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch01.vue?3edef9f9